import React, { useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';

const EmployeeLoginPage = () => {
  console.log("✅ EmployeeLoginPage component rendering...");

  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [errorMsg, setErrorMsg] = useState('');
  const [loading, setLoading] = useState(false);
  const apiBaseURL = process.env.REACT_APP_API_BASE_URL;
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    console.log("📝 Login form submitted with:", { email, password });

    setLoading(true);  // start loading
    setErrorMsg('');   // clear old errors if any

    try {
      const response = await axios.post(`${apiBaseURL}/api/employees/login`, { email, password });
      console.log("✅ Login successful:", response.data);

   	  localStorage.setItem('employeeToken', response.data.token);
	localStorage.setItem('employee_id', response.data.employee_id);

      console.log("🔐 Token and Employee ID stored in localStorage");
      console.log("🔑 Stored employee_token:", localStorage.getItem('employee_token'));
      console.log("🔑 Stored employee_id:", localStorage.getItem('employee_id'));

      navigate('/freelancer-basic-info');
    } catch (err) {
      console.error("❌ Login error:", err);
      setErrorMsg('Invalid email or password. Please try again.');
    } finally {
      setLoading(false); // stop loading no matter what
    }
  };

  return (
    <div className="flex items-center justify-center h-screen bg-gray-100">
      <div className="w-full max-w-sm p-8 bg-white rounded shadow">
        <h2 className="text-2xl font-semibold mb-6 text-center">Employee Login</h2>
        <form onSubmit={handleLogin} className="space-y-4">
          <div>
            <label className="block mb-1">Email</label>
            <input
              type="email"
              value={email}
              onChange={(e) => {
                setEmail(e.target.value);
                console.log("✏️ Email changed:", e.target.value);
              }}
              required
              className="w-full border p-2 rounded"
            />
          </div>
          <div>
            <label className="block mb-1">Password</label>
            <input
              type="password"
              value={password}
              onChange={(e) => {
                setPassword(e.target.value);
                console.log("✏️ Password changed");
              }}
              required
              className="w-full border p-2 rounded"
            />
          </div>
          <button
            type="submit"
            className={`w-full py-2 rounded text-white ${loading ? 'bg-gray-500' : 'bg-blue-600 hover:bg-blue-700'}`}
            disabled={loading}
          >
            {loading ? 'Logging in...' : 'Login'}
          </button>
          {errorMsg && <p className="text-red-600 mt-2 text-center">{errorMsg}</p>}
        </form>
      </div>
    </div>
  );
};

export default EmployeeLoginPage;
